import { Anchor } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { generatePath, Link } from "react-router";
import { ROUTES } from "../../../../routes";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

interface ProjectColumnProps {
  showProjectLinks: boolean;
}

function getProjectColumn({
  showProjectLinks
}: ProjectColumnProps): MRT_ColumnDef<SiteOverviewSite | SiteStatusSite> {
  return {
    header: "Projekt",
    accessorKey: "project",
    Cell: ({ row }) => {
      const projectPath = generatePath(ROUTES.project.entry, {
        projectId: row.original.projectId
      });

      if (showProjectLinks) {
        return (
          <Anchor component={Link} to={projectPath}>
            {row.original.project}
          </Anchor>
        );
      }

      return <span>{row.original.project}</span>;
    },
    size: 250,
    sortingFn: "text",
    filterFn: "includesString"
  };
}

export { getProjectColumn };
